import React ,{useEffect} from 'react';

import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useUserContext } from '../../context/UserStore';
import { getMyGoals } from '../../api/user';
import {GoalAccordion } from '../Accordion/GoalAccordion';

// Styled accordion container with black to gray gradient
const GradientAccordionContainer = styled('div')(({ theme }) => ({
  width: '100%',
  margin: '10px 0',
  padding: '15px',
  borderRadius: '8px',
  // Black to gray gradient
  background: 'linear-gradient(to bottom, #000000 0%, #404040 25%, #808080 50%, #404040 75%, #000000 100%)',
  backgroundSize: '100% 400%',
  animation: 'blackGrayVertical 5s ease infinite',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  
  // Apply same gradient to nested accordion components with !important to override existing styles
  '& .MuiAccordion-root': {
    background: 'linear-gradient(to bottom, #000000 0%, #404040 25%, #808080 50%, #404040 75%, #000000 100%) !important',
    backgroundSize: '100% 400% !important',
    animation: 'blackGrayVertical 5s ease infinite !important',
    borderRadius: '8px !important',
  },
  
  '& .MuiAccordionSummary-root': {
    background: 'linear-gradient(to bottom, #000000 0%, #404040 25%, #808080 50%, #404040 75%, #000000 100%) !important',
    backgroundSize: '100% 400% !important',
    animation: 'blackGrayVertical 5s ease infinite !important',
  },
  
  '& .MuiAccordionDetails-root': {
    background: 'linear-gradient(to bottom, #000000 0%, #404040 25%, #808080 50%, #404040 75%, #000000 100%) !important',
    backgroundSize: '100% 400% !important',
    animation: 'blackGrayVertical 5s ease infinite !important',
  },
  
  // Override any nested divs that might have conflicting backgrounds
  '& > div': {
    background: 'transparent !important',
  },
  
  '@keyframes blackGrayVertical': {
    '0%': {
      backgroundPosition: '0% 0%',
    },
    '50%': {
      backgroundPosition: '0% 100%',
    },
    '100%': {
      backgroundPosition: '0% 0%',
    }
  }
}));

// Helper function to determine if a goal is completed
const isGoalCompleted = (goal) => {
  // Check if goal has tasks and if they are completed
  if (!goal.tasks || goal.tasks.length === 0) {
    return 'Empty';
  }
  
  // Check if all tasks are completed (this is a simplified check)
  // You may need to adjust this based on your task completion logic
  const hasCompletedTasks = goal.tasks.some(task => 
    task.completed || task.status === 'completed' || task.done
  );
  
  return hasCompletedTasks ? 'Finished' : 'In Progress';
};

const columns = [
  {
    field: 'tasks',

    headerName: 'Tasks',
    width: 150,
    renderCell:(item)=>{
      console.log(item)
      return (<>
        <GoalAccordion notes={item.row.notes} tasks={item.value} currentGoal={false} goalName={item.row.id}/> 
      </>)
    }
  },
  {
    field: 'notes',
    headerName: 'Notes',
    width: 150,
  },
  
  {
    field: 'id',
    headerName: 'Created On',
    width: 150,
  },
];

const rows = [
  //goals
];

export default function GoalsDataGrid() {
  const { state: userState, action: userActions } = useUserContext();
  useEffect(()=>{
    userActions.getMyGoalsAsyncAction()
  },[])
  return (
    <Box sx={{ width: '100%', minHeight: 'auto' }}>
      {/* <DataGrid
      rowHeight={500}
      style={{backgroundColor:'white',margin:10}}
        rows={[...userState?.myGoals || []].reverse()}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5, 10]}
        checkboxSelection
        disableRowSelectionOnClick
      /> */}
      {[...userState?.myGoals || []].reverse().map((item, index) => {
        const completionStatus = isGoalCompleted(item);
        const statusColor = completionStatus === 'Finished' ? 'success' : 
                           completionStatus === 'Empty' ? 'error' : 'warning';
        
        return (
          <GradientAccordionContainer key={item.id || index}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                Goal #{item.id || index + 1}
              </Typography>
              <Chip 
                label={completionStatus} 
                color={statusColor}
                variant="filled"
                sx={{ 
                  fontWeight: 'bold',
                  fontSize: '0.9rem',
                  color: 'white',
                  backgroundColor: completionStatus === 'Finished' ? '#4caf50' : 
                                  completionStatus === 'Empty' ? '#f44336' : '#ff9800'
                }}
              />
            </div>
            <GoalAccordion notes={item.notes} tasks={item.tasks} currentGoal={false} goalName={item.id}/>
          </GradientAccordionContainer>
        )
      })}
    </Box>
  );
}
